import { useContext, useEffect } from "react";

import InputField from "components/input-field/input-field.component";

import { NewClientContext } from "src/contexts/new-client.context";

import useTranslate from "src/hooks/use-translate";

import { SUBSCRIPTIONS } from "utils/lists.utils";

const PagePersonal2 = ({ canContinue, toggle, index }) => {
	const {
		newCompanyData: {
			name = "",
			surname = "",
			username = "",
			vatNumber = "",
			jobTitle = "",
			email = "",
			phone = "",
			subscription = 0,
		},
		updateNewCompanyData,
	} = useContext(NewClientContext);
	const t = useTranslate("NewClientModal");

	useEffect(() => {
		if (
			canContinue &&
			(name === "" ||
				surname === "" ||
				username === "" ||
				vatNumber === "" ||
				jobTitle === "" ||
				email === "" ||
				phone === "")
		)
			toggle();
		if (
			!canContinue &&
			name.length > 0 &&
			surname.length > 0 &&
			username.length > 0 &&
			vatNumber.length > 0 &&
			jobTitle.length > 0 &&
			email.length > 0 &&
			phone.length > 0
		)
			toggle();
	}, [toggle, canContinue, name, surname, username, vatNumber, jobTitle, email, phone]);

	const handleChange = (key, value) => {
		updateNewCompanyData(key, value);
	};

	return (
		<div className="page-container page-personal-2">
			<p className="margin-xl--top w600">
				Step 2 <span className="red">|</span> Register the Client
			</p>
			<div className="grid  gap-l margin-xl--top">
				<div id="left" className="flex flex--column flex--space-between-content">
					<div className="flex flex--column gap-xl">
						<span className="flex gap-m">
							<InputField
								className="flex--grow"
								fieldType="underline"
								label="Name"
								placeholder="Jane"
								onChange={({ target: { value } }) => handleChange("name", value)}
								value={name}
							/>
							<InputField
								className="flex--grow"
								fieldType="underline"
								label="Surname"
								placeholder="Doe"
								onChange={({ target: { value } }) => handleChange("surname", value)}
								value={surname}
							/>
						</span>
						<InputField
							fieldType="underline"
							label="Username"
							placeholder="janeDoe001"
							onChange={({ target: { value } }) => handleChange("username", value)}
							value={username}
						/>
						<InputField
							fieldType="underline"
							label="Email"
							type="email"
							placeholder="jane.doe@my-company.com"
							onChange={({ target: { value } }) => handleChange("email", value)}
							value={email}
						/>
						<InputField
							fieldType="underline"
							label="Phone"
							type="tel"
							placeholder="+0123456789"
							onChange={({ target: { value } }) => handleChange("phone", value)}
							value={phone}
						/>
					</div>
				</div>
				<div id="right" className="flex flex--column gap-xl">
					<InputField
						fieldType="underline"
						label="Vat Number"
						placeholder="1234567890"
						onChange={({ target: { value } }) => handleChange("vatNumber", value)}
						value={vatNumber}
					/>
					<InputField
						fieldType="underline"
						label="Job Title"
						placeholder="Chief Financial Officer"
						onChange={({ target: { value } }) => handleChange("jobTitle", value)}
						value={jobTitle}
					/>
					<div>
						<p className="w600 size300 margin-s--block">{t("Subscription")}</p>
						<p className="size300">
							{t("Subscription will be determined based on the size and revenue of the company")}
						</p>
						<div className="flex gap-s margin-xl--top">
							{SUBSCRIPTIONS.map((subName, index) => {
								return (
									<button
										key={index}
										onClick={() => {
											handleChange("subscription", index);
										}}
										className={`w500 size400 flex--grow btn smooth-corners padding-m--left padding-s--block ${
											subscription === index && "btn--selected"
										}`}
									>
										{t(subName)}
									</button>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PagePersonal2;
